module.exports = __webpack_public_path__ + "static/media/61850.462b263e.jpg";